import * as React from 'react';
import {MainBanner} from "../components/banners/MainBanner";
import {AboutConference} from "./Main/AboutConference";
import {GalleryConference} from "./Main/GalleryConference";
import {PressConference} from "./Main/PressConference";
import {PressConference2016} from "./Main/PressConference2016";
import {Brands} from "../components/Brands";
import {News} from "./Main/News";

export class Main extends React.Component<any, any> {
    render() {
        return (
            <div>
                <MainBanner />
                <PressConference2016 />
                <News />
                <AboutConference />
                <GalleryConference />
                <PressConference />
                <Brands />
            </div>
        )
    }
}



/** WEBPACK FOOTER **
 ** ./src/route/Main.tsx
 **/